import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.space['4']};
    padding: ${theme.space['20']};
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.gray200};
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
  `,
)

export const Title = styled.div(
  ({ theme }) => css`
    text-align: center;
    font-size: 2rem;
    line-height: 2.8rem;
    color: ${theme.colors.black800};
  `,
)

export const Message = styled.div(
  ({ theme }) => css`
    text-align: center;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.black500};
  `,
)
